import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsRoutingModule } from './notifications-routing.module';
import { NotificationsComponent } from './notifications.component';
import { MasterLayoutsComponent } from './master-layouts/master-layouts.component';
import { AddComponent } from './add/add.component';
import { EditComponent } from './edit/edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AuthModule } from '../core/auth.module';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from 'ngx-clipboard';
import { BnsightsLibraryModule } from 'bnsights-control-library';
import { BlockUIModule } from 'ng-block-ui';
import { TemplatesComponent } from './templates/templates.component';
import { TemplateInfoComponent } from './template-info/template-info.component';
import { EditEmailComponent } from './edit-email/edit-email.component';
import { EditSMSComponent } from './edit-sms/edit-sms.component';
import { EditTemplateComponent } from './edit-template/edit-template.component';
import { SubheaderModule } from '../_layout/components/subheader/subheader.module';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { MatMenuModule } from '@angular/material/menu';
import { InlineSVGModule } from 'ng-inline-svg';
import { EmptyDataModule } from '../empty-data/empty-data.module';
import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bnsights-utilities-library';
import { TemplateService } from '../shared/Services/TemplateService.service';

@NgModule({
  declarations: [NotificationsComponent, MasterLayoutsComponent, AddComponent, EditComponent, TemplatesComponent, TemplateInfoComponent, EditEmailComponent, EditSMSComponent, EditTemplateComponent],
  imports: [
    NotificationsRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    AuthModule,
    RouterModule,
    CommonModule,
    ClipboardModule,
    BlockUIModule.forRoot(),
    ReactiveFormsModule,
    SubheaderModule,
    FormsModule,
    BnsightsLibraryModule,
    MatMenuModule,
    NgbModule,
    InlineSVGModule,
    EmptyDataModule
  ],
  providers: [
    EnvironmentService,
    UtilityService,
    AuthService,
    BBSFTranslateService,
    TemplateService
  ]
})
export class NotificationsModule { }
